/**
 * A module of methods that you want to include in all stores.
 * This module is consumed by `createStore`.
 */
module.exports = {
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/src/StoreMethods.js
 ** module id = 206
 ** module chunks = 0
 **/